var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"mInfo","height":"auto","width":"900","clickToClose":true}},[_c('CloseModal',{attrs:{"close":_vm.close}}),_c('div',{staticClass:"modalbox"},[_c('div',{staticClass:"modalbox-content"},[_c('carousel',{attrs:{"starting-image":1,"images":_vm.fotos,"show-progress-bar":true}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }